import * as BaseApi from "api/Base.api";

const BASE_URL = "/agency/v2/casting";

//* 요약정보 조회
//  2025.09.17
//  희문
export interface ICastingSummaryResponse {
    totalRequestCount: number;
    waitingChattingCount: number;
    canceledChattingCount: number;
    deniedChattingCount: number;
    onChattingCount: number;
    closedChattingCount: number;
}
export const getCastingSummary = async () => {
    const url = `${BASE_URL}`;
    return await BaseApi.get(url) as ICastingSummaryResponse;
};